import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';
import { withDateRange } from '@/helpers/dateRangeFilename';

// Downloads a CSV of per-user usage stats (pages, runs, matters, chronologies, Kim threads)
// for every user in the org, scoped to the given date range.
export const useDownloadUserStats = () => {
  const { getFetchConfig } = useGetFetchConfig();

  const downloadUserStats = async ({
    organisationId,
    startDate,
    endDate,
  }: {
    organisationId: string;
    startDate?: Date;
    endDate?: Date;
  }) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: { organisationId, startDate, endDate },
    });

    const response = await fetch(`${APIBaseChronos}/api/usage/user-stats/download`, fetchConfig);
    if (!response.ok) {
      throw new Error('Failed to download user stats');
    }

    const blob = await response.blob();
    const link = Object.assign(document.createElement('a'), {
      href: URL.createObjectURL(blob),
      download: withDateRange('user-usage-stats', 'csv', startDate, endDate),
    });
    link.click();
    URL.revokeObjectURL(link.href);
  };

  const { mutate: fetchDownload, isLoading } = useMutation(downloadUserStats, {
    onError: () => {
      toast.error('Failed to download user stats. Please try again.');
    },
  });

  return { fetchDownload, isLoading };
};
